module.exports = "<div class=\"loginscreen\">\n</div>"